// Generated by build/writeUIFeatureToggles.js. Do not edit. To modify/add/remove toggles, edit/create/remove the toggle files in the packages/core/src/featureToggle/UIFeatureToggles directory.
export enum UIFeatureToggle {
  InvAdvancedOrderingEnabled = 'InvAdvancedOrderingEnabled',
  InvAdvancedOrderingOnly = 'InvAdvancedOrderingOnly',
  InvAgenticCopilot = 'InvAgenticCopilot',
  InvAgreementsTabEnabled = 'InvAgreementsTabEnabled',
  InvAllowPlanNameOverrideEnabled = 'InvAllowPlanNameOverrideEnabled',
  InvBillingLedgerBetaEnabled = 'InvBillingLedgerBetaEnabled',
  InvCaseSearchFieldsEnabled = 'InvCaseSearchFieldsEnabled',
  InvChangeOfferContractApplicationEnabled = 'InvChangeOfferContractApplicationEnabled',
  InvCheckoutMiniCartOrderQuoteEnabled = 'InvCheckoutMiniCartOrderQuoteEnabled',
  InvConfigurableUsageDetailsDisplayInCare = 'InvConfigurableUsageDetailsDisplayInCare',
  InvConsolidatedCosPaymentHandlingEnabled = 'InvConsolidatedCosPaymentHandlingEnabled',
  InvContentActivityBetaEnabled = 'InvContentActivityBetaEnabled',
  InvCouponsBetaEnabled = 'InvCouponsBetaEnabled',
  InvCustomerAddressSeparationAfterCPRValidation = 'InvCustomerAddressSeparationAfterCPRValidation',
  InvDatePickerLocalizationEnabled = 'InvDatePickerLocalizationEnabled',
  InvDevicesBetaEnabled = 'InvDevicesBetaEnabled',
  InvDisableManageServiceFlow = 'InvDisableManageServiceFlow',
  InvDisableSuspendSubscriberProductFlow = 'InvDisableSuspendSubscriberProductFlow',
  InvDisplayExpectedSpeedFromServiceabilityEnabled = 'InvDisplayExpectedSpeedFromServiceabilityEnabled',
  InvEnableAcbBillRunScheduleDelete = 'InvEnableBillRunScheduleDelete',
  InvEnableAccountHierarchySearch = 'InvEnableAccountHierarchySearch',
  InvEnableAgreementSharedPoolHandlingFeature = 'InvEnableAgreementSharedPoolHandlingFeature',
  InvEnableAutoApplyNoteToFutureInvoices = 'InvEnableAutoApplyNoteToFutureInvoices',
  InvEnableCaseActivityTranslationSupport = 'InvEnableCaseActivityTranslationSupport',
  InvEnableCaseLinkingToCustomerEntities = 'InvEnableCaseLinkingToCustomerEntities',
  InvEnableCaseTypeTranslationSupport = 'InvEnableCaseTypeTranslationSupport',
  InvEnableChangeInstallationPointAutoRoute = 'InvEnableChangeInstallationPointAutoRoute',
  InvEnableChangeServiceAddress = 'InvEnableChangeServiceAddress',
  InvEnableChangeSpeed = 'InvEnableChangeSpeed',
  InvEnableCloseCaseReason = 'InvEnableCloseCaseReason',
  InvEnableCommercialDataExport = 'InvEnableCommercialDataExport',
  InvEnableCreditLimitUnbreachedNotification = 'InvEnableCreditLimitUnbreachedNotification',
  InvEnableDecentralizedAgreementSupport = 'InvEnableDecentralizedAgreementSupport',
  InvEnableDetailedTaxBreakupOnQuoteTotals = 'InvEnableDetailedTaxBreakupOnQuoteTotals',
  InvEnableDiscountAndTaxInclusiveTagDisplay = 'InvEnableDiscountAndTaxInclusiveTagDisplay',
  InvEnableDiscountEffectiveDate = 'InvEnableDiscountEffectiveDate',
  InvEnableEbubCodesForShippingGLGuidance = 'InvEnableEbubCodesForShippingGLGuidance',
  InvEnableEntitlementRenewalExpiryNotification = 'InvEnableEntitlementRenewalExpiryNotification',
  InvEnableExtendedCodeTableTranslations = 'InvEnableExtendedCodeTableTranslations',
  InvEnableFiberBoxLocationSelection = 'InvEnableFiberBoxLocationSelection',
  InvEnableFinalInvoiceGenerationOnRootInvoiceNode = 'InvEnableFinalInvoiceGenerationOnRootInvoiceNode',
  InvEnableFinalInvoiceIndicatorDisplay = 'InvEnableFinalInvoiceIndicatorDisplay',
  InvEnableFixedOnlyMarkupConfiguration = 'InvEnableFixedOnlyMarkupConfiguration',
  InvEnableGLCodeAdjustmentSegmentType = 'InvEnableGLCodeAdjustmentSegmentType',
  InvEnableGLCodeServiceSegmentType = 'InvEnableGLCodeServiceSegmentType',
  InvEnableGroupedManageOfferMenu = 'InvEnableGroupedManageOfferMenu',
  InvEnableHierarchyPaymentInstrumentSharing = 'InvEnableHierarchyPaymentInstrumentSharing',
  InvEnableInventoryAttributeTranslationSupport = 'InvEnableInventoryAttributeTranslationSupport',
  InvEnableInventorySwap = 'InvEnableInventorySwap',
  InvEnableLuhnValidation = 'InvEnableLuhnValidation',
  InvEnableMakeCustomSecurityQuestionAnswerConfigurable = 'InvEnableMakeCustomSecurityQuestionAnswerConfigurable',
  InvEnableMultiImsiServicesInUsageDetails = 'InvEnableMultiImsiServicesInUsageDetails',
  InvEnableNewTermsAndConditions = 'InvEnableNewTermsAndConditions',
  InvEnableOffcycleWriteoffandCalculatedPenaltyGLGuidanceCategories = 'InvEnableOffcycleWriteoffandCalculatedPenaltyGLGuidanceCategories',
  InvEnableOldServiceRetrieval = 'InvEnableOldServiceRetrieval',
  InvEnableOrderCancellationReason = 'InvEnableOrderCancellationReason',
  InvEnableOrderCaseWorkflowActivityErrorDetails = 'InvEnableOrderCaseWorkflowActivityErrorDetails',
  InvEnablePaymentTransfer = 'InvEnablePaymentTransfer',
  InvEnablePiiMaskingOfServiceNameAndAttributes = 'InvEnablePiiMaskingOfServiceNameAndAttributes',
  InvEnablePricingPlanEBRITranslationSupport = 'InvEnablePricingPlanEBRITranslationSupport',
  InvEnableProspectLiteToSubmitOrder = 'InvEnableProspectLiteToSubmitOrder',
  InvEnableRegexFormattedInput = 'InvEnableRegexFormattedInput',
  InvEnableRegularDiscountSegmentation = 'InvEnableRegularDiscountSegmentation',
  InvEnableSSOAutoProvisioning = 'InvEnableSSOAutoProvisioning',
  InvEnableSalesPipelineInventoryStoreFilter = 'InvEnableSalesPipelineInventoryStoreFilter',
  InvEnableSecurityRoleLifecycleDates = 'InvEnableSecurityRoleLifecycleDates',
  InvEnableServiceAttributeTranslationSupport = 'InvEnableServiceAttributeTranslationSupport',
  InvEnableServiceabilityDetails = 'InvEnableServiceabilityDetails',
  InvEnableSmartHookRerunSuppression = 'InvEnableSmartHookRerunSuppression',
  InvEnableSubscriberAdditionalPropertyGroupingAndSorting = 'InvEnableSubscriberAdditionalPropertyGroupingAndSorting',
  InvFixedFlatFeeSupportEnabled = 'InvFixedFlatFeeSupportEnabled',
  InvHideAutoPayPostpaidCycleWarningBanner = 'InvHideAutoPayPostpaidCycleWarningBanner',
  InvHideBillingSectionForOfferingOrderFlows = 'InvHideBillingSectionForOfferingOrderFlows',
  InvHideCheckoutQuoteViewEnabled = 'InvHideCheckoutQuoteViewEnabled',
  InvHidePaymentCapturedOnOrderConfirmation = 'InvHidePaymentCapturedOnOrderConfirmation',
  InvHidePricingOnOfferingGridView = 'InvHidePricingOnOfferingGridView',
  InvHideTransactionItemsEnabled = 'InvHideTransactionItemsEnabled',
  InvHierarchicalAttributeInheritanceEnabled = 'InvHierarchicalAttributeInheritanceEnabled',
  InvIFRSFeesSupportEnabled = 'InvIFRSFeesSupportEnabled',
  InvIMSIAccessFeeEnabled = 'InvIMSIAccessFeeEnabled',
  InvIncludeAddressSuggestionProviderMetadataEnabled = 'InvIncludeAddressSuggestionProviderMetadataEnabled',
  InvIncludeOrderContextInOrderVerificationHookPayloadEnabled = 'InvIncludeOrderContextInOrderVerificationHookPayloadEnabled',
  InvLiteEnabled = 'InvLiteEnabled',
  InvLockSubscriberAccountingMethod = 'InvLockSubscriberAccountingMethod',
  InvMakeAdvancedOrderingDefault = 'InvMakeAdvancedOrderingDefault',
  InvOrderItemDetails = 'InvOrderItemDetails',
  InvPlanServiceabilityEnabled = 'InvPlanServiceabilityEnabled',
  InvProductDetailsBetaEnabled = 'InvProductDetailsBetaEnabled',
  InvProductOrderStepByStepCheckoutEnabled = 'InvProductOrderStepByStepCheckoutEnabled',
  InvQuoteAndOrderDeepLinkEnabled = 'InvQuoteAndOrderDeepLinkEnabled',
  InvReactCustomPageEnabled = 'InvReactCustomPageEnabled',
  InvReactHouseholdPageEnabled = 'InvReactHouseholdPageEnabled',
  InvReactItvProductOrderFlow = 'InvReactItvProductOrderFlow',
  InvReactRestoreOrderFlow = 'InvReactRestoreOrderFlow',
  InvReactSubscriptionChangeOrderFlow = 'InvReactSubscriptionChangeOrderFlow',
  InvReactSubscriptionOrderFlow = 'InvReactSubscriptionOrderFlow',
  InvRenewalInsightEnabled = 'InvRenewalInsightEnabled',
  InvSecuritySSOLoginInfo = 'InvSecuritySSOLoginInfo',
  InvSharedPoolHandlingEnabled = 'InvSharedPoolHandlingEnabled',
  InvSkipPhysicalInventoryAvailabilityCheckEnabled = 'InvSkipPhysicalInventoryAvailabilityCheckEnabled',
  InvStudioShippingMethodsEnabled = 'InvStudioShippingMethodsEnabled',
  InvSubscriptionsBetaEnabled = 'InvSubscriptionsBetaEnabled',
  InvTelemetryExportConfigurationEnabled = 'InvTelemetryExportConfigurationEnabled',
  InvTieredRatingEnabled = 'InvTieredRatingEnabled',
  InvTotalMinimumCommitmentEnabled = 'InvTotalMinimumCommitmentEnabled',
  InvTotalsBetaEnabled = 'InvTotalsBetaEnabled',
  InvTransactionsBetaEnabled = 'InvTransactionsBetaEnabled',
  InvUnifiedOrderFlowEnabled = 'InvUnifiedOrderFlowEnabled',
  InvUseDateOnlyPickerForThreeFieldDate = 'InvUseDateOnlyPickerForThreeFieldDate'
}
